export default class StatamicObject {
  constructor({
    id,
    locale,
    url,
    title,
    metaTitle,
    metaDescription,
    doNotIndex,
    teaserImage,
    teaserExcerpt,
    header,
    content,
  }) {
    this.id = id
    this.title = title
    this.url = url
    this.teaserImage = teaserImage
    this.teaserExcerpt = teaserExcerpt
    this.locale = locale
    this.metaTitle = metaTitle
    this.metaDescription = metaDescription
    this.doNotIndex = doNotIndex
    this.header = header
    this.content = content
  }

  getSeoProps() {
    return {
      title: this.metaTitle || this.title,
      description: this.metaDescription || this.teaserExcerpt,
      meta: [
        {
          name: "robots",
          content: this.doNotIndex
            ? "noindex, nofollow"
            : "max-image-preview:large, index, follow",
        },
      ],
    }
  }
}
